import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: {},
  currentProduct: null,
  activeProductType: 'dashboard',
  typeEnums: {}
};

export const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setCurrentProduct: (state, action) => {
      state.currentProduct = action.payload;
    },
    setProducts: (state, action) => {
      state.products = action.payload.data;
    },
    setProductType: (state, action) => {
      state.activeProductType = action.payload;
    },
    setTypeEnums: (state, action) => {
      state.typeEnums = action.payload;
    },
  },
});

export const selectProducts = (state) => state.productsReducer.products;
export const selectTypeEnums = (state) => state.productsReducer.typeEnums;
export const selectActiveType = (state) => state.productsReducer.activeProductType;
export const selectCurrentProduct = (state) => state.productsReducer.currentProduct;

export const { setCurrentProduct, setProducts, setProductType, setTypeEnums } = productsSlice.actions;

export default productsSlice.reducer;
